import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardHeader, CardBody } from '../components/ui/Card';
import { CtaSection } from '../components/sections/CtaSection';
import { GraduationCapIcon, LightbulbIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
export function LearningDevelopment() {
  const expertiseAreas = [{
    title: 'Leadership Development',
    description: 'Transform managers into inspiring leaders through immersive workshops and personalized coaching.',
    icon: <UsersIcon className="h-8 w-8 text-[#0099A1]" data-id="element-1435" />,
    experts: ['Harvard Business School', 'Wharton', 'Stanford GSB']
  }, {
    title: 'Innovation & Design Thinking',
    description: 'Unlock creative problem-solving with hands-on workshops led by innovation experts.',
    icon: <LightbulbIcon className="h-8 w-8 text-[#0099A1]" data-id="element-1436" />,
    experts: ['IDEO Alumni', 'MIT Media Lab', 'Stanford d.school']
  }, {
    title: 'Strategic Planning',
    description: 'Develop actionable roadmaps with guidance from experienced strategy consultants and academics.',
    icon: <TrendingUpIcon className="h-8 w-8 text-[#0099A1]" data-id="element-1437" />,
    experts: ['McKinsey Alumni', 'London Business School', 'INSEAD']
  }, {
    title: 'Team Effectiveness',
    description: 'Build high-performing teams through evidence-based frameworks and experiential learning.',
    icon: <GraduationCapIcon className="h-8 w-8 text-[#0099A1]" data-id="element-1438" />,
    experts: ['Google re:Work Trainers', 'Gallup Certified Coaches', 'Kellogg School']
  }];
  const benefits = ['Expert-led workshops integrated into your retreat agenda', 'Immersive learning experiences in inspiring settings', 'Custom content development aligned with your objectives', 'Follow-up implementation support for lasting impact'];
  return <div className="pt-20 bg-[#F4E8D0]/30" data-id="element-1439">
      {/* Hero */}
      <section className="bg-[#0099A1] py-20" data-id="element-1440">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1441">
          <div className="max-w-3xl" data-id="element-1442">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-1443">
              World-Class Expert Network
            </h1>
            <p className="text-xl text-white/90" data-id="element-1444">
              Elevate your corporate retreat with specialized training from top
              business school professors and industry experts.
            </p>
          </div>
        </div>
      </section>

      {/* From Boardroom to Classroom to Beach */}
      <section className="py-16 bg-white" data-id="element-1445">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1446">
          <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-1447">
            <h2 className="text-3xl md:text-4xl font-bold text-[#374047] mb-6" data-id="element-1448">
              From Boardroom to Classroom to Beach
            </h2>
            <p className="text-lg text-[#374047]/80 mb-6" data-id="element-1449">
              Our exclusive network of professors from the world's top business
              schools and corporate trainers brings unparalleled expertise to
              your retreat experience.
            </p>
            <p className="text-lg text-[#374047]/80" data-id="element-1450">
              We carefully match expert facilitators to your specific
              organizational goals, creating custom learning experiences that
              drive real business outcomes.
            </p>
          </div>

          {/* Benefits */}
          <div className="max-w-3xl mx-auto mb-12" data-id="element-1451">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1452">
              {benefits.map((benefit, index) => <div key={index} className="bg-[#F4E8D0]/30 p-4 rounded-lg flex items-start" data-id="element-1453">
                  <div className="w-2 h-2 rounded-full bg-[#0099A1] mt-2 mr-3 flex-shrink-0" data-id="element-1454"></div>
                  <p className="text-[#374047]" data-id="element-1455">{benefit}</p>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Expertise Areas */}
      <section className="py-16 bg-[#F4E8D0]/30" data-id="element-1456">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1457">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-1458">
            {expertiseAreas.map((area, index) => <Card key={index} className="h-full" data-id="element-1459">
                <CardHeader className="flex flex-col items-start" data-id="element-1460">
                  <div className="mb-4" data-id="element-1461">{area.icon}</div>
                  <h3 className="text-2xl font-bold text-[#374047]" data-id="element-1462">
                    {area.title}
                  </h3>
                </CardHeader>
                <CardBody data-id="element-1463">
                  <p className="text-[#374047]/80 mb-6" data-id="element-1464">{area.description}</p>
                  <div data-id="element-1465">
                    <p className="text-sm font-semibold text-[#0099A1] mb-2" data-id="element-1466">
                      Featured Experts From:
                    </p>
                    <ul className="space-y-1" data-id="element-1467">
                      {area.experts.map((expert, i) => <li key={i} className="text-sm text-[#374047]/70 flex items-center" data-id="element-1468">
                          <span className="text-[#0099A1] mr-2" data-id="element-1469">•</span>
                          {expert}
                        </li>)}
                    </ul>
                  </div>
                </CardBody>
              </Card>)}
          </div>
        </div>
      </section>

      <CtaSection data-id="element-1470" />
    </div>;
}